<template>
  <!--    <div class="row">-->
  <!--        <strong>Disponibilizar Agenda</strong>-->
  <!--    </div>-->
  <div>
    <a-card title="Dados de Consulta" class="card-custom">
      <div class="row justify-content-center">
        <div class="col-3">
          <label for="rgCivil">RG Militar</label>
          <div class="input-group input-focus">
            <input type="text" class="form-control form-input-component" ref="rgMilitar" v-model="form.rgMilitar" id="rgMilitar" />
          </div>
        </div>
        <div class="col-3">
          <label for="cpf">CPF</label>
          <div class="input-group input-focus">
            <a-tooltip :visible="tooltipCpf" title="Necessário um cpf válido" placement="top">
              <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="form.cpf" id="cpf" />
            </a-tooltip>
          </div>
        </div>

        <div class="col">
          <div class="row">
            <label>Nome completo</label>
            <div class="col" style="padding-right: 0">
              <div class="input-group input-focus">
                <a-auto-complete v-model:value="form.nome" style="width: 200px" @search="handleSearch" class="form-control">
                  <template v-slot:dataSource>
                    <a-select-option v-for="item in pacientes" :key="item.nome" @click="onSelect(item)">
                      {{ item.nome }}
                    </a-select-option>
                  </template>
                </a-auto-complete>
              </div>
            </div>

            <div class="col-sm-1 icon-button" style="margin: 2px 24px">
              <div @click="pesquisar()"><i class="fa fa-search"></i></div>
            </div>

            <div class="col-sm-1 icon-button" style="margin: 2px 24px">
              <span @click="clearForm"><i class="fa fa-eraser"></i></span>
            </div>
          </div>
        </div>
      </div>
    </a-card>

    <!--div class="row" v-if="naoEncontrado">
			<div class="col d-flex justify-content-center">
				<strong style="color: #1b70e7">Não foi encontrado nenhum paciente com os parâmetros
					informados.</strong>
			</div>
		</div-->

    <a-card title="Pacientes" class="card-custom">
      <a-table :dataSource="dataPacientes" :columns="columns">
        <template #cpf="{ record }">
          <span>{{ formatarCpf(record.cpf) }}</span>
        </template>
        <template #servidorCpf="{ record }">
          <span>{{ formatarCpf(record.servidorCpf) }}</span>
        </template>
        <template #servidorNome="{ record }">
          <span>{{ record.servidorNome }}</span>
        </template>
        <template #action="{ record }">
          <a-tooltip :title="record.possui ? 'Editar Cadastro' : 'Novo Cadastro'" placement="left">
            <a @click="novoEditar(record)"><i :class="record.possui ? 'fas fa-edit icon-edit' : 'fas fa-add icon-add'"></i></a>
          </a-tooltip>
        </template>
        <template>
          <a-pagination :page-size(v-model)="5" :total="dataPacientes.length" />
        </template>
      </a-table>
    </a-card>

    <a-card title="Dependentes" v-if="dataDependentes.length > 0" class="card-custom">
      <a-table v-if="dependente" :dataSource="dataDependentes" :columns="columnsDependente">
        <template #action="{ record }">
          <a v-if="record.possui" @click="editarDependente(true, record)"><i class="fas fa-edit icon-edit"></i></a>
          <a v-if="!record.possui" @click="editarDependente(false, record)"><i class="fas fa-add icon-add"></i></a>
        </template>
        <template>
          <a-pagination :page-size(v-model)="5" :total="dataPacientes.totalPages" />
        </template>
      </a-table>
    </a-card>
    <a-card class="card-custom">
      <div class="row">
        <div class="col d-flex justify-content-center">
          <!--button v-if="naoEncontrado && militar" @click="goToCreate('militar')" class="btn btn-primary"
						style="margin-right: 10px">Cadastrar
						Paciente Militar
					</button-->
          <button v-if="naoEncontrado && militar" @click="goToCreate('dependente')" class="btn btn-primary" style="margin-right: 10px">Cadastrar Dependente</button>
          <!-- <button @click="goToCreate('dependente')"
                        class="btn btn-primary" style="margin-right: 10px">
                    Página
                    Paciente Dependente
                </button> -->
          <button class="btn btn-primary" style="margin-right: 10px" @click="this.$router.push({ path: '/home' })">Início</button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getDependentePorCpfMilitarNomeDependente, getPaciente } from '@/components/service/pacienteService';
import { getDependetesPorCpfMilitar, getUserSicad } from '@/config/servicos-utils';
import { openNotification, typesNotification } from '@/utils/notifications';
import { formatCpf, removeMascaraCpf, validarCpf } from '@/utils/servicos-utils';
import _ from 'lodash';

export default {
  name: 'PagePaciente',
  data() {
    return {
      naoEncontrado: false,
      form: {
        nome: undefined,
        cpf: undefined,
        rgCivil: undefined,
        tipoPaciente: undefined,
      },
      dependente: false,
      dependenteParametro: {},
      militar: false,
      dataPacientes: [],
      dataDependentes: [],
      pacientes: [],
      tooltipCpf: false,
      columns: [
        {
          title: 'Nome Completo',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'RG Militar',
          dataIndex: 'rgMilitar',
          key: 'rgMilitar',
        },
        {
          title: 'RG',
          dataIndex: 'rg',
          key: 'rg',
        },
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
          slots: { customRender: 'cpf' },
        },
        {
          title: 'Servidor CPF',
          dataIndex: 'servidorCpf',
          key: 'servidorCpf',
          slots: { customRender: 'servidorCpf' },
        },
        {
          title: 'Servidor Nome',
          dataIndex: 'servidorNome',
          key: 'servidorNome',
          slots: { customRender: 'servidorNome' },
        },
        {
          title: 'Tipo',
          dataIndex: 'tipoPaciente',
          key: 'tipoPaciente',
          slots: { customRender: 'tipoPaciente' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsDependente: [
        {
          title: 'Nome Completo',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'RG',
          dataIndex: 'rg',
          key: 'rg',
        },
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
          slots: { customRender: 'cpf' },
        },
        {
          title: 'Servidor CPF',
          dataIndex: 'servidorCpf',
          key: 'servidorCpf',
          slots: { customRender: 'servidorCpf' },
        },
        {
          title: 'Servidor Nome',
          dataIndex: 'servidorNome',
          key: 'servidorNome',
          slots: { customRender: 'servidorNome' },
        },
        {
          title: 'Tipo',
          dataIndex: 'tipoPaciente',
          key: 'tipoPaciente',
          slots: { customRender: 'tipoPaciente' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    goToCreate(type) {
      if (type === 'dependente') {
        //this.$router.push('consulta-paciente-' + type);
        localStorage.setItem('dependenteMilitar', JSON.stringify(this.dependenteParametro));
        localStorage.setItem('cpf', this.form.cpf);
        this.$router.push({ path: '/form-paciente-dependente' });
      } else {
        this.$router.push('form-paciente-' + type);
        localStorage.setItem('cpf', this.form.cpf);
      }
    },
    clearForm() {
      this.form.rgMilitar = undefined;
      this.form.cpf = undefined;
      this.form.nome = undefined;
      this.naoEncontrado = undefined;
      this.militar = undefined;
      this.dataPacientes = [];
      this.dataDependentes = [];
      this.dependenteParametro = {};
    },
    async searchPaciente() {
      this.naoEncontrado = false;
      await getPaciente(this.form).then((r) => {
        this.dataPacientes = r.data.pacientes;
        if (this.dataPacientes && this.dataPacientes.length === 0) {
          this.naoEncontrado = true;
        } else {
          this.naoEncontrado = false;
        }
      });
    },
    async pesquisar() {
      console.log();
      let pacientes = new Array();
      //paciente
      this.naoEncontrado = false;
      this.dataPacientes = new Array();
      let param = {};
      if (this.dependenteParametro.servidor) {
        param = { cpf: this.dependenteParametro.servidor.cpf };
      } else {
        param = this.form;
      }

      await getPaciente(param).then((r) => {
        for (let pacienteCadastrado of r.data.pacientes) {
          pacienteCadastrado['possui'] = true;
          pacienteCadastrado['idHpm'] = pacienteCadastrado.id;
          if (pacienteCadastrado.dependenteMilitar) {
            pacienteCadastrado['servidorCpf'] = pacienteCadastrado.dependenteMilitar.cpf;
            pacienteCadastrado['servidorNome'] = pacienteCadastrado.dependenteMilitar.nome;
          }
          pacientes.push(pacienteCadastrado);
        }

        const servidorExiste = Array.isArray(pacientes) && pacientes.some((p) => p?.cpf === this?.dependenteParametro?.servidor?.cpf);
        if (!servidorExiste && this.dependenteParametro.servidor) {
          //if (pacientes && pacientes.length === 0 && this.dependenteParametro.servidor) {
          let paciente = { ...this.dependenteParametro.servidor };
          paciente['possui'] = false;
          pacientes.push(paciente);
        }
      });

      //dependente
      var objConsulta = { corporacaoId: 61 };
      if (this.dependenteParametro.servidor) {
        objConsulta.servidorCpf = removeMascaraCpf(this.form.cpf);
      } else {
        if (this.form.cpf) {
          objConsulta.cpf = removeMascaraCpf(this.form.cpf);
        }
        if (this.form.nome) {
          objConsulta.nome = this.form.nome;
        }
      }
      await getDependetesPorCpfMilitar(objConsulta).then(async (r) => {
        for (let depen of r.data) {
          depen['tipoPaciente'] = 'DEPENDENTE';
          await getDependentePorCpfMilitarNomeDependente({
            nome: depen.nome,
            cpf: removeMascaraCpf(depen.servidorCpf),
          }).then((r) => {
            if (r.data) {
              depen['idHpm'] = r.data.id;
              depen['possui'] = true;
            } else {
              depen['possui'] = false;
            }
          });
          if (!pacientes.find((p) => p.dependenteMilitar && p.dependenteMilitar.cpf === depen.servidorCpf)) {
            pacientes.push(depen);
          }
        }

        //this.dataDependentes = r.data;

        /*if (this.dataDependentes.length === 0) {
					openNotification(typesNotification.info, 'Não foram encontrados dependentes no SICAD para este Paciente')
				} else {
					this.dependente = true;
				}*/
      });

      if (pacientes.length > 0) {
        this.dataPacientes = _.orderBy([...pacientes], ['nome'], ['asc']);
        this.naoEncontrado = true;
      } else {
        this.dataPacientes = [];
        this.naoEncontrado = true;
      }
    },
    async searchDependente() {
      var objConsulta = { corporacaoId: 61 };
      if (this.dependenteParametro.servidor) {
        objConsulta.servidorCpf = removeMascaraCpf(this.form.cpf);
      } else {
        if (this.form.cpf) {
          objConsulta.cpf = removeMascaraCpf(this.form.cpf);
        }
        if (this.form.nome) {
          objConsulta.nome = this.form.nome;
        }
      }
      await getDependetesPorCpfMilitar(objConsulta).then(async (r) => {
        for (let depen of r.data) {
          depen['tipoPaciente'] = 'DEPENDENTE';
          await getDependentePorCpfMilitarNomeDependente({
            nome: depen.nome,
            cpf: removeMascaraCpf(this.form.cpf),
          }).then((r) => {
            if (r.data) {
              depen['idHpm'] = r.data.id;
              depen['possui'] = true;
            }
          });
        }

        this.dataDependentes = r.data;

        if (this.dataDependentes.length === 0) {
          openNotification(typesNotification.info, 'Não foram encontrados dependentes no SICAD para este Paciente');
        } else {
          this.dependente = true;
        }
      });
    },
    formatarCpf(cpf) {
      return formatCpf(cpf);
    },
    validarCpf() {
      let value = this.$refs.cpf.value;
      this.$refs.cpf.classList.value = ['form-control'];
      this.tooltipCpf = false;
      if (value.length > 0 && !validarCpf(value)) {
        this.tooltipCpf = true;
        this.$refs.cpf.classList.value = ['form-control is-invalid'];
      }
    },
    novoEditar(paciente) {
      if (paciente.tipoPaciente === 'MILITAR') {
        if (!paciente.id) {
          this.$router.push('form-paciente-militar');
          localStorage.setItem('cpf', paciente.cpf);
        } else {
          this.$router.push({ path: '/form-paciente-militar/edit', query: { id: paciente.id } });
        }
      } else {
        if (paciente.idHpm) {
          this.$router.push({ path: '/form-paciente-dependente/edit', query: { id: paciente.idHpm } });
        } else {
          this.dependenteParametro = { ...paciente };
          this.dependenteParametro.servidor = { nome: paciente.servidorNome, cpf: paciente.servidorCpf, rgMilitar: '', tipoPaciente: 'MILITAR' };
          localStorage.setItem('dependenteMilitar', JSON.stringify(this.dependenteParametro));
          this.$router.push({ path: '/form-paciente-dependente' });
        }
      }
    },

    async handleSearch(value) {
      value.length >= 3
        ? await getUserSicad({ nome: value }).then((r) => {
            this.pacientes = r.data.filter((p) => p.vinculo === 'MILITAR');
          })
        : (this.pacientes = []);
    },
    onSelect(value) {
      this.form.nome = value.nome;
      this.form.cpf = value.cpf;
      this.form.rgMilitar = value.rgMilitar;
      if (value.vinculo === 'MILITAR') {
        this.militar = true;
      }
      this.dependenteParametro = { nome: '', cpfDependente: '', servidor: { nome: value.nome, cpf: value.cpf, rgMilitar: value.rgMilitar, tipoPaciente: 'MILITAR' } };
      this.naoEncontrado = false;
    },
  },
};
</script>

<style scoped>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}
</style>
